(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["water-test-popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {

  if (event.target.closest('.open-water-test-form')) {
    event.preventDefault();

    document
      .querySelector('#water-test-modal')
      .classList.add('active');
  }

  if (
    event.target.closest('.water-test-modal__close') ||
    event.target.classList.contains('water-test-modal__overlay')
  ) {
    document
      .querySelector('#water-test-modal')
      .classList.remove('active');
  }

});

  } catch(e) { console.error(e); }
})();
})();
